import type { PropsWithChildren } from 'react';

export const StyledWell = ({ children }: PropsWithChildren) => (
  <div className="flex max-w-[860px] mx-auto my-0 lg:min-h-[300px] lg:pb-0 lg:rounded-bl-[12px] lg:rounded-br-[12px]">
    <div className="px-4 md:px-11 py-9 relative w-full bg-background rounded-xl text-center mb-6 lg:shadow-[0px_1px_2px_1px_#DADCE2]">
      {children}
    </div>
  </div>
);
